import { render } from "./SpaTreatmentDetails.vue?vue&type=template&id=4c3a3fe2&scoped=true"
import script from "./SpaTreatmentDetails.vue?vue&type=script&lang=js"
export * from "./SpaTreatmentDetails.vue?vue&type=script&lang=js"

import "@/shared/css/details.css?vue&type=style&index=0&lang=css&external"
import "./SpaTreatmentDetails.vue?vue&type=style&index=1&id=4c3a3fe2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3a3fe2"]])

export default __exports__